import { render, staticRenderFns } from "./editorWeb.vue?vue&type=template&id=3a50a91d&"
import script from "./editorWeb.vue?vue&type=script&lang=js&"
export * from "./editorWeb.vue?vue&type=script&lang=js&"
import style0 from "./editorWeb.vue?vue&type=style&index=0&id=3a50a91d&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports